<span
  [class]="'iconify icon ' + classNames"
  [attr.data-icon]="name"
  [style]="style"
></span>
